/**
 * Returns the full URL for an uploaded media file.
 * Reads from REACT_APP_MEDIA_URL or falls back to the API URL (without /api).
 * 
 * Usage: getImageUrl('/uploads/drivers/abc.jpg')
 */
const BASE_MEDIA_URL = (() => {
  // If explicitly set, use it directly
  if (process.env.REACT_APP_MEDIA_URL) return process.env.REACT_APP_MEDIA_URL;
  // Derive from API URL by removing the /api suffix
  const apiUrl = process.env.REACT_APP_API_URL || 'https://draingo.in/api';
  return apiUrl.replace(/\/api\/?$/, '');
})();

/**
 * @param {string | null | undefined} path - Relative path like /uploads/folder/file.jpg
 * @returns {string | null}
 */
export const getImageUrl = (path) => {
  if (!path) return null;
  // Already a full URL
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  // Relative path - prepend media base
  return `${BASE_MEDIA_URL}${path}`;
};
